import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import HeroSection from './sections/HeroSection'
import StatsSection from './sections/StatsSection'
import BenefitsBanner from './sections/BenefitsBanner'
import PricingSection from './sections/PricingSection'
import FaqSection from './sections/FaqSection'
import ContactSection from './sections/ContactSection'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { AboutBrands } from '../About/Brands'

const Cooperation: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    // Obsługa hash fragmentów (np. #pricing)
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1))
      if (element != null) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location.hash])

  return (
    <>
      <Header />
      <HeroSection />
      <StatsSection />
      <AboutBrands />
      <BenefitsBanner />
      <PricingSection />
      <FaqSection />
      <ContactSection />
      <Footer />
    </>
  )
}

export default Cooperation
